import { duration } from 'moment';
import {
    SET_AUDIO,
    PLAY_TRACK,
    PAUSE_TRACK,
    STOP_TRACK,
    UPDATE_TIME,
    SEEK_TRACK,
    CLEAR,
    SET_SLIDER,
    SET_PLAYLIST,
    CLEAR_PLAYLIST
} from './actions';
import { parseAndSumTime } from '../../components/AudioPlayerInline';
import { buildGETUrl } from '../../utilities/buildGETUrl';


const autoplayInitial = {
    on: false,
    list: [],
    loadMoreParams: null
}
const initialState = {
    currentTrack: null,
    isPlaying: false,
    isWatching: false,
    currentTime: 0,
    currentTimeString: "00:00",
    duration: 0,
    lastPlayedId: null,
    audio: null,
    player: new Audio(),
    slider: 0,


    autoplay: autoplayInitial
};

const audioReducer = (state = initialState, action) => {
    if (action.type === PLAY_TRACK) {
        try {
            if (action.payload.filename.indexOf('http') === -1) {
                action.payload.filename = buildGETUrl("clip/play", { id: action.payload.trackId });
            }
        } catch (e) {
            console.error({ PLAY_TRACK, action });
        }


    }

    switch (action.type) {
        case SET_AUDIO:
            return {
                ...state,
                audio: action.payload
            }
        case SET_SLIDER:
            return {
                ...state,
                slider: action.payload.slider,
                currentTimeString: action.payload.currentTime
            }
        case PLAY_TRACK:
            return {
                ...state,
                currentTrack: { ...action.payload },
                duration: parseAndSumTime(action.payload.duration || "00:00"),
                currentTime: 0,
                isPlaying: true,
                isWatching: true,
                lastPlayedId: action.payload.trackId
            };

        case PAUSE_TRACK:
            return {
                ...state,
                isPlaying: false
            };

        case STOP_TRACK:
            return {
                ...state,
                isPlaying: false,
                isWatching: false,
                currentTime: 0
            };

        case UPDATE_TIME:
            return {
                ...state,
                currentTime: action.payload.currentTime,
                duration: action.payload.duration
            };

        case SEEK_TRACK:
            return {
                ...state,
                currentTime: action.payload
            };

        case CLEAR:
            return { ...initialState }

        case SET_PLAYLIST:
            return {
                ...state,
                autoplay: action.payload
            };

        case CLEAR_PLAYLIST:
            return {
                ...state,
                autoplay:  autoplayInitial
            }

        default:
            return state;
    }
};

export default audioReducer;